import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import AndroidIcon from "@mui/icons-material/Android";
import AppleIcon from "@mui/icons-material/Apple";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import SecurityIcon from "@mui/icons-material/Security";

const storageKey = "sm_pool_app_promo_seen_v1";
const androidApkUrl = "https://signamining.de/androidapp/app-release.apk";
const iosPwaUrl = "https://signamining.de/app/";
const galleryUrl = "https://signamining.de/androidapp/index.php";

export const openAppPromoDialog = () => {
    window.dispatchEvent(new CustomEvent("sm-open-app-promo"));
};

export const AppPromoDialog = () => {
    const [open, setOpen] = useState(false);

    const close = () => {
        setOpen(false);
        try {
            window.localStorage.setItem(storageKey, "1");
        } catch (_) {}
    };

    const openManually = () => setOpen(true);

    useEffect(() => {
        const onOpen = () => openManually();
        window.addEventListener("sm-open-app-promo", onOpen);

        const timer = window.setTimeout(() => {
            try {
                if (window.localStorage.getItem(storageKey) !== "1") {
                    setOpen(true);
                }
            } catch (_) {
                setOpen(true);
            }
        }, 1300);

        return () => {
            window.clearTimeout(timer);
            window.removeEventListener("sm-open-app-promo", onOpen);
        };
    }, []);

    return (
        <Dialog
            open={open}
            onClose={close}
            maxWidth="md"
            fullWidth
            PaperProps={{ className: "smAppPromoDialog" }}
        >
            <IconButton className="smAppPromoClose" aria-label="App-Hinweis schließen" onClick={close}>
                <CloseIcon />
            </IconButton>
            <DialogContent className="smAppPromoContent">
                <Box className="smAppPromoHero">
                    <img src="/banner.png" alt="Varga-Tech SIGNUM Pool" />
                    <Box className="smAppPromoBadge"><PhoneIphoneIcon /> Android & iPhone</Box>
                </Box>

                <Box className="smAppPromoBody">
                    <Typography component="p" className="smAppPromoEyebrow">
                        SignaMining Monitor
                    </Typography>
                    <Typography component="h2" className="smAppPromoTitle">
                        Deine Miner immer im Blick.
                    </Typography>
                    <Typography component="p" className="smAppPromoText">
                        Überwache deine eigenen Varga-Tech SIGNUM Miner mobil: Android als APK oder iPhone/iPad als Web-App. Deine Auswahl bleibt lokal gespeichert.
                    </Typography>

                    <Box className="smAppPromoFeatureGrid" aria-label="App Vorteile">
                        <span><SecurityIcon /> Ohne Konto</span>
                        <span><PhoneIphoneIcon /> Nur deine Miner</span>
                        <span><AndroidIcon /> Android APK</span>
                        <span><AppleIcon /> iPhone Web-App</span>
                    </Box>

                    <Stack className="smAppPromoActions" direction={{ xs: "column", sm: "row" }} spacing={1.3}>
                        <Button component="a" href={androidApkUrl} target="_blank" rel="noopener" className="smAppPromoPrimary" startIcon={<AndroidIcon />}>
                            Android laden
                        </Button>
                        <Button component="a" href={iosPwaUrl} target="_blank" rel="noopener" className="smAppPromoSecondary" startIcon={<AppleIcon />}>
                            iPhone öffnen
                        </Button>
                        <Button component="a" href={galleryUrl} target="_blank" rel="noopener" className="smAppPromoGhost">
                            Vorschau
                        </Button>
                    </Stack>

                    <Typography component="p" className="smAppPromoHint">
                        iPhone: In Safari öffnen → Teilen → Zum Home-Bildschirm. Android: APK herunterladen und Installation bestätigen.
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
};
